export default "__VITE_ASSET__q$jwTyI7__"